import claimNoteForm from "form/modal/claimNote";
import { FORM_EDIT_CLAIM_NOTE } from "../constants";

export const ModalClaimNoteForm = claimNoteForm.createContainer(FORM_EDIT_CLAIM_NOTE);
